import React from "react";
import Datetime from "react-datetime";
import FormControl from "@material-ui/core/FormControl";

const CustomDateTimePicker = ({
  label,
  dateFormat,
  value,
  onChange,
  id,
  name,
  placeHolder,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <label
        style={{
          fontWeight: "bold",
          width: "100%",
          textAlign: "left",
          color: "black",
        }}
        htmlFor={"id"}
      >
        {label}
      </label>

      <FormControl fullWidth>
        <Datetime
          closeOnSelect
          timeFormat={false}
          dateFormat={dateFormat}
          value={value || ""}
          onChange={onChange}
          inputProps={{
            name: name,
            id: id,
            placeholder: placeHolder,
            className: "custom-datetime-input",
          }}
        />
      </FormControl>
    </div>
  );
};

export default CustomDateTimePicker;
